/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedSendToFriendModalLazy_item = {
    readonly " $fragmentRefs": FragmentRefs<"AuthShareModal_item">;
    readonly " $refType": "PdpSharedSendToFriendModalLazy_item";
};
export type PdpSharedSendToFriendModalLazy_item$data = PdpSharedSendToFriendModalLazy_item;
export type PdpSharedSendToFriendModalLazy_item$key = {
    readonly " $data"?: PdpSharedSendToFriendModalLazy_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedSendToFriendModalLazy_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSendToFriendModalLazy_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AuthShareModal_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '437e118947df492f24cd985509990e74';
export default node;
